<template>
  <div class="content mb-5">
    <t-sub-nav
      class="mb-5"
      :loading="loading"
      :items="$secondaryNav.customerGroupNavItems()"
    />

    <b-row class="mb-5">
      <b-col>
        <t-data-table
          data-test-id="groups-data-table"
          disable-row-select
          with-filter
          hoverable
          :filter-placeholder="$t('Search Groups')"
          :loading="loading"
          :table-data="dataSet"
          :actions="tableActions"
          user-role="customer"
          @on-export="onExport"
          @on-row-clicked="onRowClicked"
          :searchExports="searchExports"
          @export-headers="exportedHeaders"
        />
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
  "name": "Customer Groups"
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  layout: "customer",
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("groups", ["fetchCustomerGroups"]),
    onRowClicked(item) {
      this.$router.push(`/customer/environment/groups/${item.id}`);
    },
    exportedHeaders(headers) {
      this.currentHeaders = headers;
    },
    onExport(items) {
      if (items.length) {
        const exportData = items.map((res) => {
          let payload = {};
          this.currentHeaders.forEach((headers) => {
            return (payload[headers.value] = res[headers.value]);
          });

          return payload;
        });
        this.$downloadCSV(exportData, "Groups");
      } else {
        this.displayToast({
          title: this.$t("Failure"),
          message: this.$t("No groups in table"),
          duration: 2000,
          variant: "danger",
        });
      }
    },
  },
  computed: {
    ...mapGetters("groups", ["groups"]),
    ...mapGetters("authentication", ["selectedUser"]),
  },
  watch: {
    groups() {
      this.dataSet.items = this.groups;
    },
  },
  async created() {
    this.setPageTitle(this.$t("Groups"));
    this.setPageSubtitle([
      this.$t(
        "Groups are identified through active directory integration. Once identified, groups can have policies applied to them."
      ),
    ]);

    try {
      await this.fetchCustomerGroups({ id: this.selectedUser.id });
    } finally {
      this.loading = false;
    }
  },
  data: function () {
    return {
      loading: true,
      currentHeaders: null,
      tableActions: {
        add: { enabled: false },
        export: { enabled: true },
        import: { enabled: false },
        delete: { enabled: false },
      },
      searchExports: ["name", "description", "policy_name", "users"],
      dataSet: {
        fields: [
          { value: "name", text: this.$t("Group Name"), sortable: true },
          {
            value: "description",
            text: this.$t("Description"),
            sortable: true,
          },
          { value: "policy_name", text: this.$t("Policy"), sortable: true },
          { value: "users", text: this.$t("Users"), sortable: true },
          {
            value: "last_updated",
            text: this.$t("Last Modified"),
            sortable: true,
          },
        ],
        items: [],
      },
    };
  },
};
</script>
